import React, { useState } from 'react'
import RequestInternal from '../components/RequestInternal/RequestInternal'

const RequestInternalPage = () => {
  return <RequestInternal />
}

export default RequestInternalPage
